export const getActivity = (routeName, itemId, project) => {
  const id = routeName.split("route-")[1];

  return routeName === "unassigned"
    ? project.solution.unassigned.stops.find(task => task.id === itemId).id
    : project.solution.routes
        .find(el => el.id === id)
        .stops.find(el => el.id === itemId);
};

export const getActivities = (routeName, project) => {
  const id = routeName.split("route-")[1];

  return routeName === "unassigned"
    ? project.solution.unassigned.stops
    : project.solution.routes
        .find(el => el.id === id)
        .stops.filter(
          el =>
            el.type !== "start" &&
            el.type !== "end" &&
            el.status !== "finished" &&
            el.status !== "skipped"
        );
};

// Get colors object { key(routeId): value(color index) }
export const getRouteColors = routeGroups => {
  const colorObj = {};

  Object.keys(routeGroups).reduce((sum, groupId) => {
    routeGroups[groupId].forEach((backhaulGroup, index) =>
      backhaulGroup.forEach(route => (colorObj[route.id] = sum + index))
    );

    return sum + routeGroups[groupId].length;
  }, 0);

  return colorObj;
};

export const checkFor401 = err => {
  if (!err) return false;
  if (err.status !== 401 || err.response?.status !== 401) return false;
  return true;
};

// Group routes by backhaul groups
const getBackhaulGroups = routes => {
  const backhaulGroups = {};

  routes.forEach((route, index) =>
    backhaulGroups[route.vehicle_id.split("_")[0]]
      ? backhaulGroups[route.vehicle_id.split("_")[0]].push(route)
      : (backhaulGroups[route.vehicle_id.split("_")[0]] = [route])
  );

  return Object.values(backhaulGroups);
};

// Group routes by shift
export const getFormattedRoutes = (routes, vehicles) => {
  const groups = {};

  if (vehicles.length) {
    routes.forEach(route => {
      const currentVehicle = vehicles.find(vehicle => {
        const vehicle_id = route.vehicle_id;
        const _index = route.vehicle_id.indexOf("_");
        if (_index !== -1) {
          return vehicle_id.slice(0, _index) === vehicle.vehicle_id;
        } else {
          return vehicle_id === vehicle.vehicle_id;
        }
      });
      if (currentVehicle) {
        // TODO: Removing route groups for now.
        //const field = `${currentVehicle.earliest_start}-${currentVehicle.latest_end}`;
        const field = "rtg-0";
        groups[field] = [...(groups[field] || []), route];
      }
    });
  } else {
    routes.forEach(route => {
      const start = route.stops[0];
      if (start) {
        // TODO: Removing route groups for now.
        /*
        const field =
          start.time_window_earliest !== null &&
          start.time_window_latest !== null
            ? `${start.time_window_earliest}-${start.time_window_latest}`
            : "null";
      */
        const field = "rtg-0";
        const shiftRoutes = routes.filter(
          el => el.vehicle_id === route.vehicle_id
        );

        groups[field] = [...(groups[field] || []), ...shiftRoutes];
      }
    });
  }

  Object.keys(groups).forEach(
    groupId => (groups[groupId] = getBackhaulGroups(groups[groupId]))
  );
  return groups;
};
